var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormSurveys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 125,
    viewBox: "0 0 96 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.7083 11.875H20.2917C15.9375 11.875 12.375 15.4375 12.375 19.7917V75.2083C12.375 79.5625 15.9375 83.125 20.2917 83.125H75.7083C80.0625 83.125 83.625 79.5625 83.625 75.2083V19.7917C83.625 15.4375 80.0625 11.875 75.7083 11.875ZM28.2083 27.7083H36.125V35.625H28.2083V27.7083ZM28.2083 43.5417H36.125V51.4583H28.2083V43.5417ZM28.2083 59.375H36.125V67.2917H28.2083V59.375ZM67.7917 67.2917H44.0417V59.375H67.7917V67.2917ZM67.7917 51.4583H44.0417V43.5417H67.7917V51.4583ZM67.7917 35.625H44.0417V27.7083H67.7917V35.625Z",
    fill: "#007696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormSurveys);
export default __webpack_public_path__ + "static/media/form-surveys.07917368d0e7a4b62ccfc858eb3be667.svg";
export { ForwardRef as ReactComponent };